import script from "./Certificate.vue?vue&type=script&setup=true&lang=js"
export * from "./Certificate.vue?vue&type=script&setup=true&lang=js"

import "./Certificate.vue?vue&type=style&index=0&id=57e1e33a&scoped=true&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-57e1e33a"]])

export default __exports__